import { useDispatch, useSelector } from "react-redux";
import { formatBytes } from "../common_functions/convertBytes";
import { LoadingComponent } from "./LoadingComponent";
import { SidebarDetailedView } from "./SideDetailedView";
import { PlayButtonIcon } from "../icon_templates/icons";
import { setCollections } from "../common_functions/slicers";
import { CustomizedTagSelector } from "./TagSelector";
import '../assets/styles/tags.css'
import { useEffect, useState } from "react";
import { download_files } from "../assets/constants/global_apis";
import { triggerAlert } from "./AlertMessage";

export const FileDetailedView = (props) => {
    const { thumbnail, fileDetails, isLoading, completePath, selected_backend_id, tagsList, setTagsList, mappedTags, setMappedTags, inputValue, setInputValue } = props.data;
    const [ playPauseVideo, setPlayPauseVideo ] = useState(false);
    const [availableTagas, setAvailableTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([])
    const [mappedTagsChanged,setMappedTagsChanged]=useState(false);
    const dispatch = useDispatch()
    const [url, setUrl] = useState('');

    const show_side_detailed_view = (e) => {
        e.stopPropagation();
        setUrl('');
        stream_video();
        setMappedTagsChanged(!mappedTagsChanged);//Note: this is a temporary variable since the setcollection function value won't change if the value is same, side_detailed_view functions depends on the collection, since it didn't change it won't rerender, for that we are using this variable
        dispatch(setCollections({
            path: completePath,
            backendId: selected_backend_id
        }))
        setPlayPauseVideo(true)
    }
    useEffect(() => {
        setPlayPauseVideo(false)
    },[completePath])
    const stream_video = () => {  
        fetch(`/api/v1/fetch/stream/${selected_backend_id}/${completePath}`, {
            method: "GET",
        }).then(async (response) => {
            if (!response.ok) {
                const err = await response.json();
                throw err;
            }
            return response;
        })
        .then((data) => {
            setUrl(data.headers.get('location'));
        })
        .catch(error => {
            console.error(error);
            triggerAlert('error',error.detail);
        })
    }
    return (
        <div>
            <div className="d-flex justify-content-end py-2">
                <button className="btn btn-block btn-dark px-1.5 py-1 text-sm" onClick={() => download_files([{
                    backendId: selected_backend_id,
                    path: completePath
                }])}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 me-2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    Download file
                </button>
            </div>
            <div className="position-relative">
                {playPauseVideo ? 
                <video src={url} className="img-thumb w-100" style={{ maxHeight: "65vh" }} controls autoPlay muted /> :
                <>
                <img src={thumbnail} alt="" className="img-thumb w-100" style={{ maxHeight: "65vh" }} />
                {
                    completePath?.endsWith('.mp4') &&
                    <button
                        className="btn btn-sm btn-dark rounded-0"
                        style={{ position: "absolute", top: "50%", left: "50%" }}
                        onClick={(e) => { show_side_detailed_view(e) }}
                    >
                        <PlayButtonIcon /> Play
                    </button>
                }
                </>
}
            </div>
            <table className="table table-borderless table-striped mt-2" style={{ fontSize: "0.9rem" }}>
                <tbody>
                    <tr>
                        <td style={{ width: "180px" }} className="text-muted">File Name</td>
                        <td>{fileDetails?.fileName}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "180px" }} className="text-muted">File Path</td>
                        <td>{completePath}</td>
                    </tr>
                    <tr>
                        <td className="text-muted">File Size</td>
                        <td>{formatBytes(fileDetails?.size)}</td>
                    </tr>
                    <tr>
                        <td className="text-muted">Owner</td>
                        <td>{fileDetails?.owner}</td>
                    </tr>
                    <tr>
                        <td className="text-muted">Created date</td>
                        <td>{fileDetails?.createdDate}</td>
                    </tr>
                    <tr>
                        <td className="text-muted">Tags</td>
                        <td>{<CustomizedTagSelector
                            elementsData={{ 
                                elementsList:tagsList,
                                setElementsList:setTagsList, 
                                mappedElements: mappedTags, 
                                setMappedElements: setMappedTags, 
                                inputValue:inputValue,
                                setInputValue:setInputValue,
                                videos: [
                                    {
                                        backendId: selected_backend_id,
                                        path: completePath
                                    }
                                ], 
                                title: 'Tags'
                            }} 
                            />}
                            </td>
                    </tr>
                </tbody>
            </table>
            {isLoading && <LoadingComponent tagoptions={availableTagas} selectedTags={selectedTags} />}

            {/* <SidebarDetailedView mappedTagsChanged setIsSidebarOpen={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} /> */}
        </div>
    )
}